import { render } from "./lang-select.vue?vue&type=template&id=8ec5d10e&scoped=true"
import script from "./lang-select.vue?vue&type=script&lang=ts"
export * from "./lang-select.vue?vue&type=script&lang=ts"

import "./lang-select.vue?vue&type=style&index=0&id=8ec5d10e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-8ec5d10e"

export default script